import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledSignalBoxTag = styled.div`
    padding: 1px 8px;
    border-radius: 4px;
    background-color: ${colorsPalettes.carbon[0]};
    border: 1px solid ${colorsPalettes.carbon[50]};
    ${setFontVariant("primaryItem", colorsPalettes.carbon[400])};
    font-size: 10px;
`;
